import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import AboutMenu from '../../components/menus/About';
import PostBody from './PostBody';
import RecentPosts from './RecentPosts';
import ContactBanner from '../../components/ContactBanner';

const styles = css`
  background-color: #000;
  padding: 64px 0 10px;
  @media (min-width: 768px) {
    padding: 84px 0 0;
  }
  @media (min-width: 992px) {
    padding: 98px 90px 173px;
  }
  .BlogDetail_inner {
    @media (min-width: 992px) {
      max-width: 1140px;
      margin-left: auto;
      margin-right: auto;
      display: flex;
      align-items: flex-start;
    }
  }
  .BlogDetail_postBody {
    width: 100%;
  }
  .BlogDetail_recentPosts {
    @media (min-width: 992px) {
      width: 280px;
      margin-left: 50px;
      flex-shrink: 0;
    }
    @media (min-width: 1100px) {
      width: 320px;
      margin-left: 60px;
    }
  }
`;

function BlogpostDetail({ blogpost, widget }) {
  return (
    <PageWrapper>
      <PageHelmet blogpost={blogpost} />
      <InsideHeader
        title="The Latest News"
        postTitle={get(widget, 'page_subtitle')}
        background={get(widget, 'header_image.contentUrl')}
      />
      <AboutMenu />
      <main>
        <div className={styles}>
          <div className="BlogDetail_inner">
            <PostBody className="BlogDetail_postBody" blogpost={blogpost} />
            <RecentPosts className="BlogDetail_recentPosts" />
          </div>
        </div>
      </main>
      <ContactBanner />
    </PageWrapper>
  );
}

BlogpostDetail.propTypes = {
  blogpost: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  blogpost: true,
  widget: 'blog',
})(BlogpostDetail);



// WEBPACK FOOTER //
// ./src/pages/BlogpostDetail/index.js